import React from "react";
import { getCurrentTier, getImageUrl } from "./partUtils";
import PartImageSlider from "../../hooks/partImageSlider";

const PartImage = ({
  part,
  partName,
  partMakeModel,
  partYear,
  displayPrice
}) => {
  const tier = getCurrentTier(part);
  const images = part?.imageUrls?.length
    ? part.imageUrls
    : part?.imageReferences?.length
    ? part.imageReferences
    : part?.imageUrl
    ? [part.imageUrl]
    : [getImageUrl(part)];

  return (
    <div className="aspect-[4/3] bg-secondary overflow-hidden relative group rounded-">
      <PartImageSlider
        images={images}
        alt={`Image of ${partName} for ${partMakeModel} ${partYear}`}
      />

      <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

      {tier && (
        <span
          className={`absolute top-1.5 right-1.5 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold border ${tier.bgColor} ${tier.textColor} ${tier.borderColor} shadow-sm`}
        >
          {React.createElement(tier.icon, {
            className: "w-3 h-3 shrink-0"
          })}
          {tier.label}
        </span>
      )}

      <span className="absolute bottom-1.5 left-1.5 bg-primary/80 backdrop-blur-sm text-primary-foreground text-xs font-semibold px-1.5 py-0.5 rounded">
        ${displayPrice}
      </span>
    </div>
  );
};

export default PartImage;
